import { addSurveyAnswers } from "@utils/redux/slices/surveyAnswers";
import { ActionHandlerParams } from "..";
import { updateCurrentAnswers } from "src/utils/redux/slices/currentAnswers";
import { getPageSetSurvey } from "./util";
import { WdyhauOption } from "src/components/refactored-survey/question-sets/wdyhau-questions/wdyhauOptions";
import { prepareAndTrackSurveyAnswers } from "src/utils/mainSurvey";

export const setCalAIWhereDidYouHear = ({
  store,
  pageSet,
  page,
}: ActionHandlerParams) => {
  const survey = getPageSetSurvey(pageSet, page);
  const answers = {
    whereDidYouHear: ["Cal AI"] as [string],
    whereDidYouHearKey: [WdyhauOption.other] as [WdyhauOption],
  };
  store.dispatch(addSurveyAnswers(answers));
  store.dispatch(
    updateCurrentAnswers({
      namespace: survey.surveyNameSpace,
      answers,
    })
  );

  // Track to Mixpanel
  prepareAndTrackSurveyAnswers("whereDidYouHear", answers);
};
